import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Box,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Autocomplete,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import EditFreightPayment from "./EditFreightPayment";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";

// import AddIcon from '@mui/icons-material/Add';
import {
  freightPayCreate,
  freightPayList,
  paymentPrint,
  paySettlement,
} from "../../../Services/Services";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
const FreightPaymentTable = () => {
  const [freightIdFilter, setFreightIdFilter] = useState("");
  const [payDateFilter, setPayDateFilter] = useState("");
  const [freightPaymentList, setfreightPayList] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [payRow, setPayRow] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [settelement, setSetelement] = useState(null);
  const [freightList, setFreightList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [formData, setFormData] = useState({
    total_amount: "",
    paid_amount: "",
    bal_amount: "",
    pay_amount: "",
    rem_amount: "",
    pay_mode: "",
    upi_check_no: "",
    remark: "",
    payment_to: "",
  });

  const normalizeList = (data) =>
    Array.isArray(data) ? data : data?.results || [];
  const computeHasMore = (data, list) =>
    typeof data?.next !== "undefined"
      ? !!data.next
      : Array.isArray(list)
        ? list.length > 0
        : false;

  // ---------------- Fetch (page + backend filters) ----------------
  const fetchFreightpayment = async (
    pageNo = 1,
    freightId = "",
    payDate = ""
  ) => {
    const data = await freightPayList(pageNo, {
      freight_id: freightId,
      pay_date: payDate,
    });
    const list = normalizeList(data);

    if (pageNo === 1) {
      setfreightPayList(list);
    } else {
      setfreightPayList((prev) => [...prev, ...list]);
    }

    // hasMore ko backend response ke basis pe set karo
    if (data?.next) {
      setHasMore(true);
    } else {
      setHasMore(false);
    }
  };

  // ---------------- Debounce search ----------------
  useEffect(() => {
    const t = setTimeout(() => {
      setPage(1);
      fetchFreightpayment(1, freightIdFilter, payDateFilter);
    }, 500);
    return () => clearTimeout(t);
  }, [freightIdFilter, payDateFilter]);

  // ---------------- Infinite scroll ----------------
  const fetchMoreData = async () => {
    if (!hasMore) return; // agar data khatam ho gaya to aur mat bulao
    const nextPage = page + 1;
    await fetchFreightpayment(nextPage, freightIdFilter, payDateFilter);
    setPage(nextPage);
  };
  const handlePayment = (row) => {
    setOpen(true);
    setPayRow(row);
    setFormData({
      total_amount: row.total_amount,
      paid_amount: row.paid_amount,
      bal_amount: row.rem_amount,
    });
  };
  const handleClose = () => setOpen(false);
  const handleCloseEdit = () => {
    setOpenEdit(false);
    fetchFreightpayment();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if at least one row has pay_amount
    const validRows = rows.filter(
      (row) => row.pay_amount && Number(row.pay_amount) > 0
    );

    if (validRows.length === 0) {
      alert("Please fill at least one pay amount");
      return;
    }

    const existingPayments = payRow.payments ?? [];

    const addPayment = {
      ...payRow,
      payments: [
        ...existingPayments,
        ...validRows.map((row) => ({
          pay_amount: row.pay_amount,
          payment_to: row.payment_to,
          upi_check_no: row.upi_check_no,
          pay_mode: row.pay_mode,
          remark: formData.remark, // single remark for all rows (or make row-wise if needed)
        })),
      ],
      rem_amount: (
        Number(payRow.rem_amount) -
        validRows.reduce((acc, row) => acc + Number(row.pay_amount), 0)
      ).toFixed(2),
      paid_amount: (
        Number(payRow.paid_amount) +
        validRows.reduce((acc, row) => acc + Number(row.pay_amount), 0)
      ).toFixed(2),
    };

    const response = await freightPayCreate(
      addPayment.freight_payment_id,
      addPayment
    );

    if (response) {
      setfreightPayList(response);
      setOpen(false);

      // Reset form and rows
      setFormData({
        paid_amount: "",
        bal_amount: "",
        pay_amount: "",
        rem_amount: "",
        pay_mode: "",
        upi_check_no: "",
        remark: "",
        payment_to: "",
      });
      setRows([
        { pay_amount: "", payment_to: "", pay_mode: "", upi_check_no: "" },
      ]);
    }
  };

  const [openViewModal, setOpenViewModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const handleView = (row) => {
    setSelectedRow(row);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setSelectedRow(null);
  };

  const handleEdit = (row) => {
    setSelectedRow(row); // store the row to edit
    setOpenEdit(true); // open the modal
  };

  const handleExportExcel = () => {
    const table = document.getElementById("freight-payment");
    const rows = Array.from(table.querySelectorAll("tr"));
    const ws_data = [];

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll("th, td"));
      const rowData = cells
        .filter((cell) => !cell.classList.contains("no-print"))
        .map((cell) => cell.innerText);
      ws_data.push(rowData);
    });

    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    const colWidths = ws_data[0].map((_, colIndex) => {
      const maxLength = ws_data.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, ws_data[0][colIndex].length);
      return { wch: maxLength + 2 };
    });
    ws["!cols"] = colWidths;

    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    const headerLength = ws_data[0].length;
    for (let c = 0; c < headerLength; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r: 0, c })];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } },
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    }

    for (let r = 1; r < ws_data.length; r++) {
      for (let c = 0; c < headerLength; c++) {
        const cell = ws[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FreightPayment");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Freight_Payment_List.xlsx");
  };

  const handlePrintHTML = () => {
    const table = document.getElementById("freight-payment");
    if (!table) return;

    const clonedTable = table.cloneNode(true);

    const removeIndexes = new Set();
    const headerRow = clonedTable.querySelector("thead tr");
    if (headerRow) {
      headerRow.querySelectorAll("th").forEach((th, idx) => {
        if (
          th.classList.contains("no-print") ||
          th.querySelector("input[type='checkbox']")
        ) {
          removeIndexes.add(idx);
        }
      });
    }

    clonedTable.querySelectorAll("tr").forEach((row) => {
      const cells = Array.from(row.children);
      cells.forEach((cell, idx) => {
        if (
          removeIndexes.has(idx) ||
          cell.classList.contains("no-print") ||
          cell.querySelector("input[type='checkbox']")
        ) {
          cell.remove();
        }
      });
    });

    const printContent = clonedTable.outerHTML;
    const printWindow = window.open("", "", "width=1000,height=600");

    printWindow.document.write(`
    <html>
    <head>
      <style>
        @media print {
          html, body {
            zoom: 90%;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          table, tr, td, th {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }

          .no-print {
            display: none !important;
          }

          @page {
            margin: 15mm;
          }
        }

        body {
          font-family: Arial, sans-serif;
          padding: 10px 20px;
          margin: 0;
        }

        header {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 10px;
          color: #333;
        }

        footer {
          position: fixed;
          bottom: 10px;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #333;
        }

        h3 {
          text-align: center;
          margin: 0 0 20px 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          text-align: center;
          font-size: 12px;
          white-space: nowrap;
        }

        th {
          background-color: rgba(211, 211, 211, 0.42);
          color: #000;
        }
      </style>
    </head>
    <body>
      <header>SR ENTERPRICES</header>
      <h3>Freight Payment List</h3>
      ${printContent}
      <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
      <script>
        window.onload = function () {
          window.print();
          window.onafterprint = function () {
            window.close();
          };
        };
      </script>
    </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
  };

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
  const handlePrintSingleRow = async (row) => {
    const data = await paymentPrint(row.freight_payment_id);

    const printWindow = window.open("", "", "width=900,height=600");

    row.payments = data[0] ? data[0].payments : [];
    row.freights = data[0] ? data[0].freights : [];

    // Generate additional table with heading and multiple payment entries
    let additionalTableHTML = "";

    if (Array.isArray(row.freights) && row.freights.length > 0) {
      additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Freight Id</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Truck No</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Load Wt</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Unload Wt </th>
        <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Net Payble</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Date</th>
        </tr>
      </thead>
      <tbody>
  `;

      row.freights.forEach((freight) => {
        additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${freight.freight_id || ""}</td>
                <td style="text-align:center;">${freight.truck_no || ""}</td>
        <td style="text-align:center;">${freight.loading_wt || ""}</td>
        <td style="text-align:center;">${freight.received_wt || ""}</td>
        <td style="text-align:center;">${freight.net_payable || ""}</td>
         <td style="text-align:center;">${formatOnlyDate(freight.created_at) || ""
          }</td>
      </tr>
    `;
      });

      additionalTableHTML += `
      </tbody>
    </table>
  `;
    }

    // If multiple payments exist

    if (Array.isArray(row.payments) && row.payments.length > 0) {
      additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amt</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Pay Mode</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">UPI/Cheque No.</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Payment To</th>
        <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Remark</th>
          </tr>
      </thead>
      <tbody>
  `;

      row.payments.forEach((payment) => {
        additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${payment.pay_amount || ""}</td>
        <td style="text-align:center;">${payment.pay_mode || ""}</td>
        <td style="text-align:center;">${payment.upi_check_no || ""}</td>
        <td style="text-align:center;">${payment.payment_to || ""}</td>
         <td style="text-align:center;">${payment.remark || ""}</td>
      </tr>
    `;
      });

      additionalTableHTML += `
      </tbody>
    </table>
  `;
    }

    if (Array.isArray(data) && data.length > 0) {
      additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Total Amount</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amount</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Balance Amount</th>
          </tr>
      </thead>
      <tbody>
  `;

      data.forEach((payment) => {
        additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${payment.total_amount.toFixed(2) || ""
          }</td>
        <td style="text-align:center;">${payment.paid_amount.toFixed(2) || ""
          }</td>
        <td style="text-align:center;">${payment.rem_amount.toFixed(2) || ""
          }</td>
      </tr>
    `;
      });

      additionalTableHTML += `
      </tbody>
    </table>
  `;
    }
    printWindow.document.write(`
    <html>
      <head>
        <title>Print Freight Row</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          header {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
          }
          footer {
            position: fixed;
            bottom: 10px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          td {
            font-size: 14px;
            vertical-align: top;
          }
          th {
            background-color:rgba(211, 211, 211, 0.42);
            font-weight: bold;
          }
          td[style*="background-color"], th[style*="background-color"] {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        </style>
      </head>
      <body>
        <header>SR ENTERPRICES</header>

        <table border="1" style="border: 1px solid black; border-collapse: collapse;" cellpadding="5">
          <tr>
            <td>Ashutosh Ku. Singh</td>
            <td>Payment ID: ${row.freight_payment_id}</td>
        
          </tr>
          <tr>
            <td>Branch Name: ${row.branch_name}</td>
            <td>Payment Date : ${formatOnlyDate(row.created_at)}</td>
         
          </tr>
        </table>

        <br>

      

        <table border="1" style="border-collapse: collapse; width: 100%;" cellpadding="5">
          <tbody>
            ${additionalTableHTML}
          </tbody>
        </table>

        <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>

        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = function () {
              window.close();
            };
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const handleComplete = async (id) => {
    const data = await paySettlement(id);
    setfreightPayList(data);
  };

  // This Function For Dialog
  // state for multiple rows
  const [rows, setRows] = useState([
    {
      pay_amount: "",
      payment_to: "",
      pay_mode: "",
      upi_check_no: "",
    },
  ]);

  // Add new row
  const handleAddRow = () => {
    setRows([
      ...rows,
      { pay_amount: "", payment_to: "", pay_mode: "", upi_check_no: "" },
    ]);
  };

  // Delete specific row by index
  const handleDeleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  // Change handler for row inputs
  const handleRowChange = (index, e) => {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
  };

  return (
    <div style={{ width: "100%", maxHeight: "calc(100vh - 70px)" }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          mb: 2,
          py: 1,
          alignItems: "center",
          gap: 2,
          position: "sticky",
          top: 10,
          zIndex: 1000,
        }}
      >
        <TextField
          label="Search by Freight ID"
          size="small"
          value={freightIdFilter}
          onChange={(e) => setFreightIdFilter(e.target.value)}
          sx={{ flex: "1 1 250px",marginTop: -4 }}
        />

        <TextField
          label="Search by Pay Date"
          size="small"
          value={payDateFilter}
          onChange={(e) => setPayDateFilter(e.target.value)}
          sx={{ flex: "1 1 250px",marginTop: -4 }}
        />

        <Button
          variant="outlined"
          onClick={handleExportExcel}
          sx={{ minWidth: "40px", height: "40px", padding: 0 ,marginTop: -4}}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>
        <Button
          variant="outlined"
          onClick={handlePrintHTML}
          sx={{ minWidth: "40px", height: "40px", padding: 0 ,marginTop: -4}}
        >
          <PrintIcon fontSize="small" />
        </Button>
      </Box>

      {/* Table */}
      <InfiniteScroll
          dataLength={freightPaymentList.length}
          next={fetchMoreData}
          hasMore={hasMore}
          // loader={<h4 style={{ textAlign: "center" }}>Loading...</h4>}
          scrollableTarget="scrollableDiv"
        >
      <TableContainer
        id="scrollableDiv"
        sx={{
          maxHeight: "75vh",
          overflowX: "auto",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        
          {/* <div style={{ maxHeight: "75vh", overflowX: "auto" }}> */}
          <Table
            stickyHeader
            size="small"
            id="freight-payment"
            sx={{
              minWidth: "100%",
              tableLayout: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "0px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableCell
                  className="no-print"
                  sx={{
                    position: "sticky",
                    left: 0,
                  }}
                >
                  Settlement{" "}
                </TableCell>
                <TableCell>Sr No.</TableCell>
                <TableCell>Pay Id</TableCell>
                <TableCell>Branch</TableCell>
                <TableCell>Freight ID</TableCell>
                <TableCell>Total Amt</TableCell>
                <TableCell>Paid Amt</TableCell>
                <TableCell>Rem Amount</TableCell>
                <TableCell>Pay Date</TableCell>
                <TableCell
                  align="center"
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 3,
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {freightPaymentList.map((row, index) => {
                const freightIds = Array.isArray(row.freights)
                  ? row.freights.map((f) => f.freight_id).join(", ")
                  : Array.isArray(row.freight_id)
                    ? row.freight_id.join(", ")
                    : row.freight_id ?? "";

                const payDate = row.created_at
                  ? formatOnlyDate(row.created_at)
                  : row.freights?.[0]?.created_at
                    ? formatOnlyDate(row.freights[0].created_at)
                    : "";

                const totalAmt =
                  typeof row.total_amount === "number"
                    ? row.total_amount.toFixed(2)
                    : "-";
                const paidAmt =
                  typeof row.paid_amount === "number"
                    ? row.paid_amount.toFixed(2)
                    : "-";
                const remAmt =
                  typeof row.rem_amount === "number"
                    ? row.rem_amount.toFixed(2)
                    : "-";

                return (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: row.is_settlement
                        ? "#d4edda" // light green for settled
                        : row.rem_amount < -20
                          ? "#f8d7da" // light red for very negative remaining amount
                          : index % 2 === 0
                            ? "#fafafa"
                            : "#ffffff",
                      "& td": {
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                      }}
                      padding="checkbox"
                    >
                      <Checkbox
                        size="small"
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setSetelement(row.freight_payment_id);
                        }}
                      />
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.freight_payment_id}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>
                      {Array.isArray(row.freights) && row.freights.length > 0 ? (
                        <Tooltip
                          arrow
                          placement="top"
                          title={
                            <div
                              style={{
                                maxHeight: "200px", // यहाँ अपनी ज़रूरत के हिसाब से height सेट करें
                                overflowY: "auto",
                              }}
                            >
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  fontSize: "12px",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid white",
                                        padding: "2px 6px",
                                        background: "black",
                                        fontWeight: "bold",
                                        color: "white",
                                      }}
                                    >
                                      Freight ID
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid white",
                                        padding: "2px 6px",
                                        background: "black",
                                        fontWeight: "bold",
                                        color: "white",
                                      }}
                                    >
                                      Truck No
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {row.freights.map((freight, i) => (
                                    <tr key={i}>
                                      <td
                                        style={{
                                          border: "1px solid white",
                                          padding: "2px 6px",
                                        }}
                                      >
                                        {freight.freight_id}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid white",
                                          padding: "2px 6px",
                                        }}
                                      >
                                        {freight.truck_no}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          }
                        >
                          <span style={{ cursor: "pointer" }}>
                            {row.freights[0].freight_id}
                            {row.freights.length > 1 ? " ..." : ""}
                          </span>
                        </Tooltip>
                      ) : (
                        row.freight_id
                      )}
                    </TableCell>



                    <TableCell>{row.total_amount.toFixed(2)}</TableCell>
                    <TableCell>{row.paid_amount.toFixed(2)}</TableCell>
                    <TableCell>{row.rem_amount.toFixed(2)}</TableCell>
                    <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      {/* Eye Icon (View Details) */}
                      <IconButton
                        color="info"
                        size="small"
                        onClick={() => handleView(row)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>

                      {/* Add Icon (Add Payment) */}
                      <IconButton
                        color="success"
                        size="small"
                        // onClick={() => handleAddPayment(row)}
                        onClick={() => handlePayment(row)}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleEdit(row)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handlePrintSingleRow(row)}
                      >
                        <PrintIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {/* </div> */}
       
      </TableContainer> </InfiniteScroll>

      <Dialog
        open={openEdit}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            width: "1200px",
            height: "600px",
            maxWidth: "90%",
            overflow: "auto",
          },
        }}
      >
        <form onSubmit={handleSubmit}>
          <EditFreightPayment
            data={selectedRow}
            freightOptions={freightList}
            branchOptions={branchList}
            onClose={handleCloseEdit}
            selectedFreight={selectedRow?.freights}
          />
        </form>
      </Dialog>

      {/*Dialog Box */}
      <Dialog open={open} maxWidth="lg" fullWidth>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add Payment</DialogTitle>
          <DialogContent>
            <Box component="form" noValidate sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    name="total_amount"
                    label="Total Amount"
                    type="number"
                    value={formData.total_amount}
                    onChange={handleChange}
                    disabled
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    name="paid_amount"
                    label="Paid Amount"
                    type="number"
                    value={formData.paid_amount}
                    onChange={handleChange}
                    disabled
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    name="bal_amount"
                    label="Bal Amount"
                    type="number"
                    value={formData.bal_amount}
                    onChange={handleChange}
                    disabled
                    required
                  />
                </Grid>

                {/* This Row Duplicate After Clicking Plus Icon */}

                {rows.map((row, index) => (
                  <Grid
                    container
                    spacing={2}
                    key={index}
                    alignItems="center"
                    sx={{ mt: 1, ml: index > 0 ? 0 : 0 }}
                  >
                    <Grid item xs={12} sm={2.8}>
                      <TextField
                        fullWidth
                        name="pay_amount"
                        label="Pay Amount"
                        type="number"
                        value={row.pay_amount}
                        onChange={(e) => handleRowChange(index, e)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2.8}>
                      <TextField
                        fullWidth
                        name="payment_to"
                        label="Payment To"
                        value={row.payment_to}
                        onChange={(e) => handleRowChange(index, e)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2.8}>
                      <TextField
                        fullWidth
                        name="pay_mode"
                        label="Payment Mode"
                        value={row.pay_mode}
                        onChange={(e) => handleRowChange(index, e)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2.8}>
                      <TextField
                        fullWidth
                        name="upi_check_no"
                        label="UPI / Cheque No."
                        value={row.upi_check_no}
                        onChange={(e) => handleRowChange(index, e)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={0.4}>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteRow(index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}

                {/* Plus Button Row */}
                <Grid
                  item
                  xs={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <IconButton color="primary" onClick={handleAddRow}>
                    <AddIcon fontSize="large" />
                  </IconButton>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="rem_amount"
                    label="Total Bal Amount"
                    type="number"
                    // Index Based Calculation Apply AutoMatic.
                    value={(
                      Number(formData.bal_amount || 0) -
                      rows.reduce(
                        (acc, row) => acc + Number(row.pay_amount || 0),
                        0
                      )
                    ).toFixed(2)}
                    onChange={handleChange}
                    disabled
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="remark"
                    label="Remark"
                    rows={3}
                    value={formData.remark}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" type="submit">
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/*Dialog Box For Eye Icon (View Details) */}
      <Dialog
        open={openViewModal}
        onClose={handleCloseViewModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>View Details</DialogTitle>
        <DialogContent dividers>
          {selectedRow ? (
            <>
              <Table
                size="small"
                sx={{
                  border: "1px solid rgba(224, 224, 224, 1)",
                  "& td, & th": {
                    border: "1px solid rgba(224, 224, 224, 1)",
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <strong>Branch Name</strong>
                    </TableCell>
                    <TableCell>{selectedRow.branch_name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Total Amount</strong>
                    </TableCell>
                    <TableCell>{selectedRow.total_amount}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Paid Amount</strong>
                    </TableCell>
                    <TableCell>{selectedRow.paid_amount.toFixed(1)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Remaining Amount</strong>
                    </TableCell>
                    <TableCell>{selectedRow.rem_amount.toFixed(1)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <br />
              <Table
                size="small"
                sx={{
                  border: "1px solid rgba(224, 224, 224, 1)",
                  "& td, & th": {
                    border: "1px solid rgba(224, 224, 224, 1)",
                  },
                }}
              >
                <TableRow>
                  <TableCell>Pay Amt</TableCell>
                  <TableCell>Pay Mode</TableCell>
                  <TableCell>Payment To</TableCell>
                  <TableCell>Upi/Check No</TableCell>
                </TableRow>
                {selectedRow?.payments?.map((freight, index) => (
                  <TableRow>
                    <TableCell>{freight.pay_amount}</TableCell>
                    <TableCell>{freight.pay_mode}</TableCell>
                    <TableCell>{freight.payment_to}</TableCell>
                    <TableCell>{freight.upi_check_no}</TableCell>
                  </TableRow>
                ))}
              </Table>
            </>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewModal}>Close</Button>
        </DialogActions>
      </Dialog>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setSetelement(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleComplete(settelement);
                } finally {
                  setAnchorEl(null);
                  setSetelement(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setSetelement(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </div>
  );
};

export default FreightPaymentTable;
